/* eslint-disable no-underscore-dangle */
import { SimpleGrid } from '@mantine/core'
import clsx from 'clsx'
import { Fragment } from 'react'
import { PhotoProvider, PhotoView } from 'react-photo-view'

import { ShopifyImage } from 'src/components/ShopifyImage/ShopifyImage'

import styles from './ProductPhotoGrid.module.scss'

import 'react-photo-view/dist/react-photo-view.css'

import type { Image, MediaImage, Video } from 'src/data/graphql-generated'

interface ProductPhotoGridProps {
  images: Partial<Image | MediaImage | Video>[]
}

export const ProductPhotoGrid = ({ images }: ProductPhotoGridProps) => {
  const soloImage = images.length === 1
  // * $pdp-max-image-xy || $pdp-min-image-xy
  const imageXY = soloImage ? 550 : 330

  return (
    <SimpleGrid cols={soloImage ? 1 : 2} spacing="sm">
      <PhotoProvider speed={() => 0} maskOpacity={0.7}>
        {images?.map((media, i) => {
          if (media.__typename === 'Image') {
            return (
              <PhotoView key={media.id} src={media.url}>
                <div className={clsx(styles.imageWrapper, soloImage && styles.solo)}>
                  <ShopifyImage
                    key={media.id}
                    image={media}
                    className={clsx(styles.image)}
                    height={imageXY}
                    width={imageXY}
                    preload={i === 0}
                  />
                </div>
              </PhotoView>
            )
          }
          if (media.__typename === 'MediaImage') {
            return (
              <PhotoView key={media.image?.id} src={media.image?.url}>
                <div className={clsx(styles.imageWrapper, soloImage && styles.solo)}>
                  <ShopifyImage
                    key={media.id}
                    image={media.image}
                    className={clsx(styles.image)}
                    height={imageXY}
                    width={imageXY}
                    preload={i === 0}
                  />
                </div>
              </PhotoView>
            )
          }
          if (media.__typename === 'Video') {
            return (
              <Fragment key={media.id}>
                <video preload="none" key={media.id} playsInline muted loop autoPlay className={styles.video}>
                  <source src={media.sources?.[0].url} type="video/mp4" />
                </video>
              </Fragment>
            )
          }
          return null
        })}
      </PhotoProvider>
    </SimpleGrid>
  )
}
